import React from 'react';

import {Percentage} from 'shells/percentage/percentage';

import type {ComparisonMetricType} from 'nutshell-graphql-types';
import type {GetEditionEngagementStats_edition_engagementStats} from 'nutshell-graphql-types';

type Props = {
    comparisonMetricType: ComparisonMetricType;
    versionAStats: GetEditionEngagementStats_edition_engagementStats;
    versionBStats: GetEditionEngagementStats_edition_engagementStats;
    versionAIsWinning: boolean;
    hasWinner: boolean;
    isTied: boolean;
};

export function PercentageText(props: Props) {
    if (props.comparisonMetricType === 'OPEN_RATE') {
        const winnerOpenRate = props.versionAIsWinning ? (
            // @ts-expect-error
            <Percentage value={props.versionAStats.openRate} />
        ) : (
            // @ts-expect-error
            <Percentage value={props.versionBStats.openRate} />
        );

        const loserOpenRate = props.versionAIsWinning ? (
            // @ts-expect-error
            <Percentage value={props.versionBStats.openRate} />
        ) : (
            // @ts-expect-error
            <Percentage value={props.versionAStats.openRate} />
        );

        if (props.hasWinner) {
            return (
                <div>
                    It sent with an open rate of {winnerOpenRate}&nbsp;while{' '}
                    {props.versionAIsWinning ? 'Version B' : 'Version A'} had {loserOpenRate}
                </div>
            );
        }

        if (props.isTied) {
            return <div>Both versions have an open rate of {winnerOpenRate}</div>;
        }

        return (
            <div>
                It currently has an open rate of {winnerOpenRate}&nbsp;while{' '}
                {props.versionAIsWinning ? 'Version B' : 'Version A'} has {loserOpenRate}
            </div>
        );
    }

    const winnerClickRate = props.versionAIsWinning ? (
        // @ts-expect-error
        <Percentage value={props.versionAStats.clickRate} />
    ) : (
        // @ts-expect-error
        <Percentage value={props.versionBStats.clickRate} />
    );

    const loserClickRate = props.versionAIsWinning ? (
        // @ts-expect-error
        <Percentage value={props.versionBStats.clickRate} />
    ) : (
        // @ts-expect-error
        <Percentage value={props.versionAStats.clickRate} />
    );

    if (props.hasWinner) {
        return (
            <div>
                It sent with a click rate of {winnerClickRate}&nbsp;while{' '}
                {props.versionAIsWinning ? 'Version B' : 'Version A'} had {loserClickRate}
            </div>
        );
    }

    if (props.isTied) {
        return <div>Both versions have a click rate of {winnerClickRate}</div>;
    }

    return (
        <div>
            It currently has a click rate of {winnerClickRate}&nbsp;while{' '}
            {props.versionAIsWinning ? 'Version B' : 'Version A'} has {loserClickRate}
        </div>
    );
}
